import colors, { appTheme } from '@/config/colors';
import { ResetPassword } from '@/screens/Login/ResetPassword';
import { PublicConfirmationPage } from '@/screens/PublicConfirmationPage';
import { useNavigation } from '@react-navigation/native';
import {
  StackNavigationProp,
  createStackNavigator,
} from '@react-navigation/stack';
import { parse } from 'expo-linking';
import { useEffect } from 'react';
import 'typescript/lib/lib.dom.d.ts'; // adds support for web globals as we need them here
import Login from '@/screens/Login';
import { SignUpController } from '@/screens/Registration/SignUpController';
import { ReactivateAccount } from '@/screens/Login/ReactivateAccount';
import { Filler } from '@/screens/Filler';
import { IS_WEB } from '@/utils/platform';
import { isTherapistApp } from '@/config/constants';
import { View, Image } from 'react-native';

export type AnonymousStackParamList = {
  ResetPassword: {
    email?: string;
  };
  EmailVerification: { token: string };
  PublicConfirmationPage: { title: string; text: string };
  SignUpController: undefined;
  Login: {
    email?: string;
  };
  Privacy: undefined;
  ReactivateAccount: {
    reactivationToken: string;
  };
};

const Stack = createStackNavigator<AnonymousStackParamList>();

export function AnonymousStack() {
  const { navigate } =
    useNavigation<StackNavigationProp<AnonymousStackParamList>>();

  useEffect(() => {
    if (!IS_WEB) {
      return;
    }
    const { queryParams } = parse(location.href);

    if (typeof queryParams?.['email-verified'] === 'string') {
      navigate('PublicConfirmationPage', {
        title: 'Account aktiviert',
        text: 'Vielen Dank für die Verifizierung Ihrer E-Mail-Adresse! \n Sie können die neolexon Aphasie App jetzt auf dem Tablet oder Computer verwenden.',
      });
      history.pushState({}, '', '/');
      return;
    }
    navigate('Login', {});
  }, []);

  return (
    <Stack.Navigator
      initialRouteName={'Login'}
      screenOptions={{
        gestureEnabled: false,
        headerStyle: { backgroundColor: appTheme.primary, height: 88 },
        headerTitleAllowFontScaling: false,
        headerTitleAlign: 'center',
        headerTitleStyle: {
          color: colors.white,
          fontSize: 18,
          fontWeight: '600',
        },
      }}
    >
      <Stack.Screen
        name="Login"
        component={Login}
        options={{
          title: 'Login',
          headerShown: isTherapistApp,
          headerTitleAllowFontScaling: false,
          headerLeft: () => {
            return (
              <View
                style={{
                  paddingLeft: 16,
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <Image
                  source={require('../assets/neolexon-icon.png')}
                  style={{ width: 40, height: 40, marginRight: 8 }}
                  resizeMode="contain"
                />
                <Image
                  source={require('../assets/neolexon-name.png')}
                  style={{ width: 120, height: 35 }}
                  resizeMode="contain"
                />
              </View>
            );
          },
        }}
      />
      <Stack.Screen
        name="ResetPassword"
        component={ResetPassword}
        options={{ title: 'Neues Passwort vergeben', headerShown: false }}
      />
      <Stack.Screen
        name="PublicConfirmationPage"
        component={PublicConfirmationPage}
        options={{ title: 'Neues Passwort vergeben', headerShown: false }}
      />
      <Stack.Screen
        name="ReactivateAccount"
        component={ReactivateAccount}
        options={{ headerShown: false, presentation: 'modal' }}
      />
      <Stack.Screen
        name="Privacy"
        component={Filler}
        options={{
          headerShown: false,
          presentation: 'modal',
        }}
      />
      <Stack.Screen
        name="SignUpController"
        component={SignUpController}
        options={{
          headerTitle: 'Registrierung',
          gestureEnabled: false,
          headerTintColor: colors.white,
          headerStyle: { backgroundColor: appTheme.primary },
          headerLeftContainerStyle: { paddingHorizontal: 8 },
          headerRightContainerStyle: { paddingHorizontal: 16 },
          headerBackTitle: 'Zurück',
          headerMode: 'float',
          headerTitleAlign: 'center',
          headerTitleAllowFontScaling: false,
        }}
      />
    </Stack.Navigator>
  );
}
